import React from 'react';
import { Shield, FileCheck, Award, Building } from 'lucide-react';

const Compliance = () => {
  const standards = [
    {
      icon: Building,
      title: 'MNRE Guidelines',
      description: 'Full adherence to Ministry of New and Renewable Energy standards'
    },
    {
      icon: FileCheck,
      title: 'State DISCOM Regulations',
      description: 'Compliance with all state distribution company requirements'
    },
    {
      icon: Shield,
      title: 'Grid Safety Standards',
      description: 'Meeting operational and safety protocols for grid integration'
    },
    {
      icon: Award,
      title: 'Quality Certifications',
      description: 'Industry-standard certifications and quality assurance'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Compliance & Governance</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our compliance-first approach ensures long-term asset stability and lender confidence
          </p>
        </div>

        {/* Standards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {standards.map((standard, index) => (
            <div 
              key={index}
              className="text-center p-8 bg-gray-50 rounded-2xl hover:bg-emerald-50 transition-all duration-300 group"
            >
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm group-hover:shadow-md transition-shadow duration-300">
                <standard.icon className="w-8 h-8 text-emerald-700" />
              </div>
              <h3 className="font-bold text-gray-900 mb-3">{standard.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{standard.description}</p>
            </div>
          ))}
        </div>

        {/* Governance Statement */}
        <div className="bg-gradient-to-br from-gray-50 to-emerald-50 rounded-2xl p-12 border border-emerald-100">
          <div className="max-w-4xl mx-auto text-center">
            <Shield className="w-12 h-12 text-emerald-700 mx-auto mb-6" />
            <p className="text-lg text-gray-700 leading-relaxed">
              We operate with strict adherence to MNRE guidelines, State DISCOM regulations, and grid safety & operational standards. Our compliance-first approach ensures long-term asset stability and lender confidence.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Compliance;
